// extracted by mini-css-extract-plugin
module.exports = {"hidden":"company_hidden__T3JO4","textEmphasis":"company_textEmphasis__YmRTw","companyWrap":"company_companyWrap__w8Dd0"};